import React, { useState } from 'react';
import {
  Form, Input, Button, message, Switch, Breadcrumb,
} from 'antd';
import { useNavigate, Link } from 'react-router-dom';
import { useKeycloak } from '@react-keycloak/web';
import { createUser } from '../services/api';
import SettingsField, { SettingsPanel } from '../components/settings/SettingsField';
import './AddAssistant.css';

const CreateUser = () => {
  const navigate = useNavigate();
  const { keycloak } = useKeycloak();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (values) => {
    setLoading(true);
    try {
      await createUser(keycloak, values);
      message.success('User created successfully');
      navigate('/users');
    } catch (error) {
      message.error('Failed to create user: ' + (error.response?.data?.detail || error.message));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page-container add-assistant-page">
      <div className="add-assistant-form-panel is-single">
        <Form
          form={form}
          className="add-assistant-form-inner"
          layout="vertical"
          onFinish={handleSubmit}
          initialValues={{ enabled: true }}
        >
          <div className="settings-main is-full">
            <div className="add-assistant-page-intro">
              <Breadcrumb
                className="add-assistant-breadcrumb"
                items={[
                  { title: <Link to="/users">Users</Link> },
                  { title: 'Create user' },
                ]}
              />
              <h1 className="add-assistant-page-title">Create user</h1>
              <p className="add-assistant-page-subtitle">
                Add a person who can sign in through Keycloak.
              </p>
            </div>

            <SettingsPanel>
              <SettingsField label="Username" help="Used to sign in. Letters, numbers, and dots.">
                <Form.Item
                  name="username"
                  rules={[{ required: true, message: 'Username is required' }]}
                  style={{ marginBottom: 0, width: '100%' }}
                >
                  <Input placeholder="jane" />
                </Form.Item>
              </SettingsField>
              <SettingsField label="Email" help="Where account mail is sent.">
                <Form.Item
                  name="email"
                  rules={[
                    { required: true, message: 'Email is required' },
                    { type: 'email', message: 'Enter a valid email' },
                  ]}
                  style={{ marginBottom: 0, width: '100%' }}
                >
                  <Input placeholder="jane@company.com" />
                </Form.Item>
              </SettingsField>
              <SettingsField label="First name" help="Shown next to the account.">
                <Form.Item name="firstName" style={{ marginBottom: 0, width: '100%' }}>
                  <Input placeholder="Jane" />
                </Form.Item>
              </SettingsField>
              <SettingsField label="Last name" help="Shown next to the account.">
                <Form.Item name="lastName" style={{ marginBottom: 0, width: '100%' }}>
                  <Input placeholder="Doe" />
                </Form.Item>
              </SettingsField>
              <SettingsField label="Password" help="At least 8 characters. They can change it after the first sign-in.">
                <Form.Item
                  name="password"
                  rules={[
                    { required: true, message: 'Password is required' },
                    { min: 8, message: 'Minimum 8 characters' },
                  ]}
                  style={{ marginBottom: 0, width: '100%' }}
                >
                  <Input.Password placeholder="At least 8 characters" />
                </Form.Item>
              </SettingsField>
              <SettingsField label="Account enabled" help="When off, they cannot sign in.">
                <Form.Item name="enabled" valuePropName="checked" noStyle>
                  <Switch />
                </Form.Item>
              </SettingsField>
            </SettingsPanel>

            <div className="add-assistant-form-footer">
              <Button onClick={() => navigate('/users')}>Cancel</Button>
              <Button type="primary" htmlType="submit" loading={loading}>
                Create
              </Button>
            </div>
          </div>
        </Form>
      </div>
    </div>
  );
};

export default CreateUser;
